<template>
  <div class="w-full h-full relative">
    <ModelView
      :loadModelType="loadModelType"
      :modelTreeProp="modelTreeProp"
      :sceneOptions="sceneOptions"
      @loadModelEnd="loadModelEnd"
      @sendPlayer="sendPlayer"
    ></ModelView>
    <template v-if="loadModelStatus">
      <div class="w-full absolute bottom-0 justify-center flex">
        <BasicTab
          v-if="allowOperate"
          class="absolute"
          :tags="basicTabList"
          :selectTagList="selectTagList"
          @tagsClick="tagsBasicClick"
        ></BasicTab>
      </div>
      <div
        v-for="item in componentList"
        :key="item.id"
        :class="item.location.float === 'left' ? 'left-10px' : 'right-10px'"
        class="absolute top-[50px] bg-[#ffffff66] h-[calc(100%-70px)]"
      >
        <component
          v-if="item.show"
          :location="item.location"
          :is="item.component"
          :player="player"
          :loadModelStatus="loadModelStatus"
          :customProps="customProps"
          :modelNode="modelNode"
          :modelTreeProp="customProps.modelTreeProp"
          :sourceId="sceneOptions.id"
          @componentEmit="handleComponentEmit"
          @closeComponent="closeComponent"
        ></component>
      </div>
    </template>
  </div>
</template>

<script>
import { tagsClick, removeTagsStatus, initParams } from '../assets/js/model/commonMethods'
import exportComponents from '../assets/js/export/componentsList'

export default {
  components: { ...exportComponents },
  props: {
    loadModelType: {
      type: String,
      defalut: 'modelFileId',
    },
    sceneOptions: {
      type: Object,
      defalut: () => {
        return {
          isEnableGis: false,
          latitude: 0,
          longitude: 0,
          name: '',
          id: '',
          folderId: '',
          jsonData: '',
        }
      },
    },
    // modelTreeProp: {
    //   type: Object,
    //   default: () => {
    //     return {
    //       currentNodeItem: 0, // 当前激活的node
    //       currentNodeName: '', // 点选时当前激活的节点名称
    //       treeData: [], // 模型树数据
    //       defaultCheckedKey: [], // 模型树选中的节点
    //       filterItem: [], // 模型树不需要显示的节点及他的父节点列表
    //       modelHideList: [], // 模型隐藏队列
    //       modelTreeLoadEnd: false, // 模型树数据加载完毕
    //       spaceSwapStatus: false, // 交换空间状态
    //     }
    //   },
    // },
  },
  data() {
    return {
      loadModelStatus: false,
      componentCustomProps: {},
      selectTagList: [],
      componentList: [], // 当前激活的弹框列表
      customProps: {
        // 模型树相关
        modelTreeProp: {
          currentNodeItem: 0, // 当前激活的node
          currentNodeName: '', // 点选时当前激活的节点名称
          treeData: [], // 模型树数据
          defaultCheckedKey: [], // 模型树选中的节点
          filterItem: [], // 模型树不需要显示的节点及他的父节点列表
          modelHideList: [], // 模型隐藏队列
          modelTreeLoadEnd: false, // 模型树数据加载完毕
          spaceSwapStatus: false, // 交换空间状态
        },
        sceneId: '',
        loadModelStatus: false,
        mode: 'visualization',
      },
      basicTabList: [
        // {
        //   code: 'ModelTree',
        //   name: '模型树',
        //   maxHeight: '33rem',
        //   minHeight: '20rem',
        //   direction: 'left',
        //   icon: 'icon-yxr-modelTree',
        // },
        {
          code: 'system.Pickup',
          name: '点选',
          icon: 'icon-yxr-clickSelect',
        },
        // {
        //   children: [
        //     {
        //       code: 'system.ToolShowModel',
        //       name: '显示上一个',
        //       icon: 'icon-yxr-showPrevious',
        //     },
        //     {
        //       code: 'system.ToolShowAll',
        //       icon: 'icon-yxr-showAllHidden',
        //       name: '显示全部',
        //     },
        //     {
        //       code: 'system.ToolHideModel',
        //       icon: 'icon-yxr-hide',
        //       name: '隐藏选中节点',
        //     },
        //   ],
        //   code: 'system.ToolHide',
        //   icon: 'icon-yxr-hide',
        //   name: '隐藏工具',
        // },
      ],
      allowOperate: false,
      player: {},
      labelList: [],
      modelTreeProp: {
        currentNodeItem: 0, // 当前激活的node
        currentNodeName: '', // 点选时当前激活的节点名称
        treeData: [], // 模型树数据
        defaultCheckedKey: [], // 模型树选中的节点
        filterItem: [], // 模型树不需要显示的节点及他的父节点列表
        modelHideList: [], // 模型隐藏队列
        modelTreeLoadEnd: false, // 模型树数据加载完毕
        spaceSwapStatus: false, // 交换空间状态
      },
      modelNode: {}, // 点选模型，获取模型的节点node
    }
  },
  watch: {
    sceneOptions: {
      handler(val, old) {
        console.log(val, old)
        if ((!old && val) || val.id !== old.id) {
          localforage.removeItem('activeTagDetail')
          initParams()
          this.loadModelStatus = false
          this.customProps.loadModelStatus = false
          this.componentCustomProps = {}
          this.selectTagList = []
          this.componentList = []
          this.allowOperate = false
          this.labelList = []
          this.modelNode = {}
          this.customProps = this.$options.data().customProps
          this.modelTreeProp = this.$options.data().modelTreeProp
        }
        console.log(this.loadModelStatus, '= false= false= false')
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    async loadModelEnd() {
      window.player = this.player

      setTimeout(() => {
        this.loadModelStatus = true
        this.allowOperate = true
        this.customProps.loadModelStatus = true
      }, 500)

      this.$emit('loadModelEnd')
    }, // 处理组件事件
    handleComponentEmit(key, data) {
      this.$set(this.componentCustomProps, key, data)
    }, // 关闭弹框组件
    async closeComponent(com) {
      const activeTagData = (await localforage.getItem('activeTagDetail')) || {}
      if (_.isEmpty(activeTagData) || !activeTagData.activeTags) {
        return
      }
      const removeTag = _.filter(activeTagData.activeTags, ['code', com])
      this.selectTagList = removeTagsStatus(removeTag, this.componentList)
    },
    async tagsBasicClick(code, tag) {
      this.selectTagList = (await tagsClick(tag, this.componentList, this.player)) || []
    },
    sendPlayer(val) {
      this.player = val
      this.$emit('sendPlayer', val)
    },
  },
  mounted() {
    localforage.removeItem('activeTagDetail')
  },
  beforeDestroy() {
    localforage.removeItem('activeTagDetail')
  },
}
</script>

<style lang="scss" scoped>
</style>
